import { createSlice } from "@reduxjs/toolkit";
import {
  addWholesaleOrder,
  getWholesaleOrderByID,
  getWholesaleOrders,
  updateWholesaleOrder,
} from "./wholesale.action";
import { IWholesaleState } from "./wholesale.interface";

const initialState: IWholesaleState = {
  filters: {
    search: "",
    sort: "inserted",
    order: "desc",
    page: 0,
    limit: 10,
  },
  selectedWholesales: [],

  // Get Wholesale
  isWholesaleLoading: false,
  wholesaleError: "",
  wholesales: [],
  pagination: {
    page: 0,
    size: 10,
    length: 0,
  },

  // Get Wholesale by ID
  wholesaleByID: null,
  isWholesaleByIDLoading: false,
  wholesaleByIDError: "",

  // Add Wholesale
  isAddWholesaleLoading: false,
  addWholesaleSuccess: false,
  addWholesaleError: "",

  // Update Wholesale
  isUpdateWholesaleLoading: false,
  updateWholesaleSuccess: false,
  updateWholesaleError: "",
};

const wholesaleSlice = createSlice({
  name: "wholesale",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setSelectedWholesales: (state, action) => {
      state.selectedWholesales = action.payload;
    },
    setWholesaleFilters: (state, action) => {
      state.filters = action.payload;
    },
    resetAddWholesale: (state) => {
      state.addWholesaleSuccess = false;
      state.addWholesaleError = "";
    },
    resetUpdateWholesale: (state) => {
      state.updateWholesaleSuccess = false;
      state.updateWholesaleError = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getWholesaleOrders.pending, (state) => {
      state.isWholesaleLoading = true;
    });
    builder.addCase(getWholesaleOrders.fulfilled, (state, action) => {
      state.isWholesaleLoading = false;
      state.wholesales = action.payload.wholesaleOrders;
      state.pagination = action.payload.pagination;
    });
    builder.addCase(getWholesaleOrders.rejected, (state, action) => {
      state.isWholesaleLoading = false;
      state.wholesaleError = action.payload;
    });

    builder.addCase(getWholesaleOrderByID.pending, (state) => {
      state.isWholesaleByIDLoading = true;
    });
    builder.addCase(getWholesaleOrderByID.fulfilled, (state, action) => {
      state.isWholesaleByIDLoading = false;
      state.wholesaleByID = action.payload;
    });
    builder.addCase(getWholesaleOrderByID.rejected, (state, action) => {
      state.isWholesaleByIDLoading = false;
      state.wholesaleByIDError = action.payload;
    });

    builder.addCase(addWholesaleOrder.pending, (state) => {
      state.isAddWholesaleLoading = true;
    });
    builder.addCase(addWholesaleOrder.fulfilled, (state) => {
      state.isAddWholesaleLoading = false;
      state.addWholesaleSuccess = true;
    });
    builder.addCase(addWholesaleOrder.rejected, (state, action) => {
      state.isAddWholesaleLoading = false;
      state.addWholesaleError = action.payload;
    });

    builder.addCase(updateWholesaleOrder.pending, (state) => {
      state.isUpdateWholesaleLoading = true;
    });
    builder.addCase(updateWholesaleOrder.fulfilled, (state) => {
      state.isUpdateWholesaleLoading = false;
      state.updateWholesaleSuccess = true;
    });
    builder.addCase(updateWholesaleOrder.rejected, (state, action) => {
      state.isUpdateWholesaleLoading = false;
      state.updateWholesaleError = action.payload;
    });
  },
});

export default wholesaleSlice.reducer;

export const {
  setFilters,
  setSelectedWholesales,
  setWholesaleFilters,
  resetAddWholesale,
  resetUpdateWholesale,
} = wholesaleSlice.actions;
